import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectProduct } from 'services/products/selectors';
import { selectUnitTypesKeyedById } from 'services/unitTypes/selectors';
import formatDropdownOptions from 'utils/format-dropdown-options';
import { options } from './constants';

const selectUnitTypeName = createDeepEqualSelector(
    selectProduct,
    selectUnitTypesKeyedById,
    (product, unitTypesKeyedById) => {
        if (product) {
            const unitTypeName = get(
                unitTypesKeyedById,
                [product.unitTypeId, 'name'],
                ''
            );

            return unitTypeName;
        }

        return '';
    }
);

const selectOptions = createDeepEqualSelector(
    selectUnitTypeName,
    (unitTypeName) =>
        formatDropdownOptions(options, {
            keyField: 'key',
            textField: ({ text }) => `${unitTypeName}/${text}`
        })
);

const makeSelectOptions = (): typeof selectOptions => selectOptions;

export { selectUnitTypeName, makeSelectOptions };
